import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
`

const Table = styled.table`
  border-collapse: collapse;
  margin-bottom: ${props => props.theme.margins.lg};
`

const TableHeader = styled.thead`

`

const TableBody = styled.tbody`

`

const TableHeaderRow = styled.tr`
  border-bottom: 1px solid #ddd;
  background: #eee;
  color: ${props => props.theme.colors.text};
`

const TableRow = styled.tr`
  &:nth-of-type(2n) {
    background: #eee;
  }

  &:last-of-type {
    border-bottom: 1px solid #ddd;
  }
`

const TableHeaderCell = styled.th`
  padding: ${props => props.theme.margins.md};
  text-align: left;
`

const TableCell = styled.td`
  padding: ${props => props.theme.margins.sm} ${props => props.theme.margins.md};
  line-height: 1.55;
`

// Replaces <br /> strings in text into valid DOM elements
const breakLine = text => {
    const br = React.createElement('br');
    const regex = /(<br \/>)/g;
    return text.split(regex).map( (line, index) =>
      line.match(regex) ? <br key={`key_${index}`} /> : line
    );
}
const TextBlock = ({table, blockNumber}) => (
  <Wrapper>
    <Table >
      <TableHeader>
        <TableHeaderRow>
          { table.headers.map( cell =>
            <TableHeaderCell key={cell}>{cell}</TableHeaderCell>
          )}
        </TableHeaderRow>
      </TableHeader>

      <TableBody>
        {table.rows.map( (row,index) =>
          <TableRow key={index}>
            {row.map(item =>
              <TableCell key={item}>{breakLine(item)}</TableCell>
            )}
          </TableRow>
        )}
      </TableBody>

    </Table>
  </Wrapper>)

export default TextBlock;



// WEBPACK FOOTER //
// ./src/book/blocks/TableBlock.js